import { initialState } from './orderCandidateMatch.redux';
import { RootState } from 'types';
import { createSelector } from '@reduxjs/toolkit';

const selectDomain = (state: RootState) => state?.orderCandidateMatch || initialState;

export const selectOrderCandidateMatch = createSelector([selectDomain], data => data);
export const selectFilterSpecs = createSelector([selectDomain], data => data.filterSpecs);
export const selectPayload = createSelector([selectDomain], data => data.payload);
export const selectAppliedFilters = createSelector([selectDomain], data => data.appliedFilters);
export const selectOrderCandidateMatchChips =  createSelector([selectDomain], data => data.chips);